import { ClientType } from '~/types/resources/ClientType';
import { OptionType } from '../../../../../../src/component/PaginatedSelect/type';

/**
 * クライアント情報をセレクト用のオプション型に変換する
 */
export const clientToOption = (client: ClientType): OptionType => ({
  label: client.name,
  value: client.name,
});
